// Website-specific version: plain localStorage, no Tauri dependency at all.
//
// The desktop app's version of this file imports @tauri-apps/plugin-store
// and falls back to localStorage if that plugin throws at runtime -- that
// pattern doesn't work here, because this project never has
// @tauri-apps/plugin-store installed in the first place. A *static*
// `import { Store } from "@tauri-apps/plugin-store"` would fail to resolve
// at BUILD time (Vite can't bundle a package that isn't in node_modules),
// not just at runtime -- the desktop app's try/catch only guards against
// runtime failures, so copying that file here as-is would break `npm run
// build` outright, not gracefully degrade.
//
// Kept async (even though localStorage itself is synchronous) so this has
// the exact same call signature as the desktop app's version -- pages
// written against `await Storage.get(...)` etc. work unmodified either way.
export const Storage = {
  async get(key, fallback = null) {
    try {
      const raw = localStorage.getItem(key);
      return raw ? JSON.parse(raw) : fallback;
    } catch {
      return fallback;
    }
  },

  async set(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch {
      // localStorage unavailable (private browsing quota, etc.) -- nothing
      // more we can do here.
    }
  },

  async remove(key) {
    try {
      localStorage.removeItem(key);
    } catch {
      // localStorage unavailable -- nothing more we can do here.
    }
  },
};
